// https://vuex.vuejs.org/en/mutations.html

export default {
    setLogin: state => (state.isLogin = true),
    setLogout: state => (state.isLogin = false),

    isLogged(state) {
        return state.isLogin;
    },
    getProvs(state) {
        return state.iraqprovs;
    },
    getRules(state) {
        return state.nameRules;
    },

    setEditDialogState(state, obj) {
        state.isEditDialogShow = obj;
    },
    getEditDialogState(state) {
        return state.isEditDialogShow;
    },
    setLoginInfo(state, obj) {
        state.loggedUser = obj;
    },
    setTokenInfo(state, obj) {
        state.token = obj;
    },
};
